import axios from "axios"
import moment from "moment"

export class DigitalMeterReport {
  constructor() {
    this.TIMEOUT   = 30000;
  }
  static async getMonthReport(cust_id, selectedMonth, selectedYear){
    let lastDayOfLastMonth = moment({month: selectedMonth - 2, year: selectedYear}).daysInMonth()
    let url = 'https://dbs.cplservice.net/apiman.php/electric?filter[]=cust_id,eq,' + cust_id + '&transform=1&order=cpl_post_id,asc&page=1,100&filter[]=update_date,ge,' + selectedYear + '-' + (parseInt(selectedMonth) - 1) + '-' + lastDayOfLastMonth + '&filter[]=update_date,lt,' + selectedYear + '-' + (parseInt(selectedMonth) + 1) + '-01&filter[]=update_time,gt,23:45:00';
    let { data } = await axios({
      method: 'get',
      url: url,
      timeout: this.TIMEOUT,
    });
    return data.electric
  }
  static async getMonthReports(cust_id_list, selectedMonth, selectedYear){
    let result = []
    for(let cust_id of cust_id_list){
      let data = await DigitalMeterReport.getMonthReport(cust_id, selectedMonth, selectedYear)
      result.push(data)
    }
    return result
  }
  static async getDateReport(cust_id_list, date){
    let result = []
    for(let cust_id of cust_id_list){
      let _date = moment(date).format('YYYY-MM-DD')
      let url = 'https://dbs.cplservice.net/apiman.php/electric?filter[]=cust_id,eq,' + cust_id + '&transform=1&order=cpl_post_id,asc&page=1,100&filter[]=update_date,eq,' + _date + '&filter[]=update_time,gt,00:00:00';
      let { data } = await axios({
        method: 'get',
        url: url,
        timeout: this.TIMEOUT,
      });
      result.push(data.electric)
    }
    return result
  }
}